module.exports = {"pt-BR":{"components":{"paginator":{"first":"Início","prev":"","next":"","last":"Fim"}}}}